













































































/**
 * @author wangyingxu1
 * header-nav
 */

import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import api from '@/api';
import request from '@/server';
import { sysId } from '@/config';
import { setCookie, getCookie, logout } from '@/util';

@Component({})
export default class HeaderNav extends Vue {
  @Prop({ type: [String, Number], default: '' }) public defaultSubjectCode?: string | number;

  public subjectMouseStatus: boolean = false;
  public subjectCode: string | number = '';
  public subjectOptions: any[] = [];
  public user: any = {};
  public isDfub: boolean = false;
  public get subjectName(): string {
    const currentSubject =
      this.subjectOptions.find((item: any): boolean => item.perCode === this.subjectCode);
    if (!currentSubject) {
      return `${this.subjectCode}`;
    }
    return currentSubject.perName || `${this.subjectCode}`;
  }

  public created(): void {
    let user: any = {};
    try {
      const userJson: string = getCookie('user') || '{}';
      user = JSON.parse(userJson);
    } catch (e: any) {
      //
    }
    this.user = user;
  }

  public mounted(): void {
    this.isDfub = location.host.indexOf('dfub.com') > -1 || (this.user && this.user.email && this.user.email.indexOf('dfub.com') > -1);
    this.init();
  }

  public init(): void {
    this.getSubjectOptions();
  }

  public getSubjectOptions(): void {
    // localhost没有cookie 请求接口会返回999登出
    if (window.location.host.indexOf('localhost') !== -1) {
      this.subjectOptions = [
        {
          'perPid': '',
          'perCode': '12',
          'perName': '科学',
          'perType': 'subject',
          'perIndex': '',
          'sysId': '',
          'sysPerId': ''
        },
        {
          'perPid': '',
          'perCode': '15',
          'perName': '美术',
          'perType': 'subject',
          'perIndex': '',
          'sysId': '',
          'sysPerId': ''
        },
        {
          'perPid': '',
          'perCode': '19',
          'perName': '不区分',
          'perType': 'subject',
          'perIndex': '',
          'sysId': '',
          'sysPerId': ''
        },
        {
          'perPid': '',
          'perCode': '2',
          'perName': '数学',
          'perType': 'subject',
          'perIndex': '',
          'sysId': '',
          'sysPerId': ''
        },
        {
          'perPid': '',
          'perCode': '3',
          'perName': '英语',
          'perType': 'subject',
          'perIndex': '',
          'sysId': '',
          'sysPerId': ''
        },
        {
          'perPid': '',
          'perCode': '1449',
          'perName': '创客',
          'perType': 'subject',
          'perIndex': '',
          'sysId': '',
          'sysPerId': ''
        },
        {
          'perPid': '',
          'perCode': '996',
          'perName': '素养',
          'perType': 'subject',
          'perIndex': '',
          'sysId': '',
          'sysPerId': ''
        }
      ];
      return;
    }

    const params = {
      sysId,
      email: this.user.email
    };

    request({
      url: api.baseLabelOptions,
      method: 'post',
      data: params
    }).then((res: any): void => {
      this.subjectOptions = res.subject || [];

      const subjectCode: string | number = this.getDefaultSubjectCode();
      if (subjectCode !== '') {
        this.subjectChange(subjectCode);
      }
    });
  }

  public getDefaultSubjectCode(): string | number { // 设置默认学科
    // 1.cookie
    let subjectCode: string | number = getCookie('subject-code') || '';
    if (this.subjectCodeIsInSubjectOptions(subjectCode)) {
      return subjectCode;
    }

    // 2.defaultSubjectCode
    subjectCode = this.defaultSubjectCode || '';
    if (this.subjectCodeIsInSubjectOptions(subjectCode)) {
      return subjectCode;
    }

    // 3.取权限学科第一位
    subjectCode = this.subjectOptions[0] ? this.subjectOptions[0].perCode : '';
    return subjectCode;
  }

  // 判断subjectCode是否在权限学科中
  public subjectCodeIsInSubjectOptions(subjectCode: string | number): boolean {
    const currentSubjectIndex: number =
      this.subjectOptions.findIndex((item: any): boolean => item.perCode === subjectCode);
    return currentSubjectIndex !== -1;
  }

  public subjectMouseEnter(): void {
    this.subjectMouseStatus = true;
  }

  public subjectMouseLeave(): void {
    this.subjectMouseStatus = false;
  }

  public logout(): void {
    logout();
  }

  public userChange(btnType: string): void {
    switch (btnType) {
      case 'logout':
        this.logout();
        break;
      default:
        break;
    }
  }

  @Emit('subject-change')
  public subjectChange(value: string | number) {
    this.subjectCode = value;
    setCookie('subject-code', String(value), '.xdf.cn', 1000);
    return value;
  }
}

